import ctaMan from "assets/images/psp/inlineCTA.jpg";
import HeaderBackgroundDesktop from "assets/images/psp/hero/military-hero.webp";
import HeaderBackgroundMobile from "assets/images/psp/hero/military-header-mobile.webp";
import HeaderBackgroundTablet from "assets/images/psp/hero/military-header-tablet.webp";
import illustrationSearch from "assets/images/psp/illustration-search.svg";
import GeorgeRansom from "assets/images/psp/review-george.png";
import AnnAlarcon from "assets/images/psp/review-ann.png";
import SMurphy from "assets/images/psp/review-murphy.png";
import MilitaryStorageBenefitsImage from "assets/images/psp/military-storage-benefits.webp";
import SelfStorageHero from "assets/images/psp/long-term-storage-cost.webp";
import MilitaryHero from "assets/images/psp/military-storage.webp";
import { storageCategories } from "pages/PSPPage/utils/getPSPLinks";

const faqs = [
	{
		question: "Do storage facilities offer military discounts?",
		answer: "Yes, most facilities near military bases provide discounts ranging from 10-20% for active duty, reservists, and veterans. Some also waive administrative fees or deposits when you present military ID and orders—always ask about military storage facility benefits when booking."
	},
	{
		question: "Can I store my POV while deployed or stationed overseas?",
		answer: "Absolutely. Military vehicle storage is common at facilities near bases and offers secure, often climate-controlled spaces for cars, motorcycles, and trucks. Many provide battery maintenance services to keep your vehicle road-ready upon return, and some allow family members access for periodic starts."
	},
	{
		question:
			"How does military move temporary storage work with PCS orders?",
		answer: "Military move temporary storage accommodates the gap between duty stations when timing doesn't align. You can store household goods short-term (typically 1-3 months) using month-to-month rental terms, and many facilities work flexibly with changed orders or delayed housing availability."
	},
	{
		question: "What should I store during deployment?",
		answer: "Most service members store furniture, electronics, seasonal items, and sentimental belongings in a military storage facility. Climate-controlled units protect against temperature and humidity damage for extended deployments—size your unit based on whether you're storing a barracks room or an entire household."
	},
	{
		question: "Is my military allowance enough to cover storage costs?",
		answer: "Storage allowances vary by rank, family status, and PCS type. Your base transportation office can detail covered expenses—some military move temporary storage costs qualify for reimbursement, while long-term deployment storage typically comes out-of-pocket unless covered by other benefits."
	}
];

const relatedContentCards = [
	{
		category: "Moving Advice",
		url: "https://www.storage.com/blog/how-self-storage-can-help-military-members-and-families/",
		date: "November 4, 2025",
		image: MilitaryHero,
		content: "How Self Storage Can Help Military Members and Families"
	},
	{
		category: "Self Storage",
		url: "https://www.storage.com/blog/long-term-storage-cost/",
		date: "August 16, 2025",
		image: SelfStorageHero,
		content: "A Quick Guide to Long Term Storage Costs"
	},
	{
		category: "Self Storage",
		url: "https://www.storage.com/blog/cost-of-car-storage/",
		date: "September 8, 2025",
		image: "https://www.storage.com/blog/wp-content/uploads/2024/09/outdoorparking-jpg.webp",
		content:
			"How Much Does Vehicle Storage Cost? Comprehensive Guide with Price Comparisons"
	}
];

const pspLinksContent = {
	title: "More Ways to Store",
	image: illustrationSearch,
	storageTypes: storageCategories.military
};

const reviewsContent = {
	title: "Storage.com has a 4.4 out of 5 star rating on",
	testimonials: [
		{
			body: "The person from Storage.com who assisted me was super helpful and offered several options. I saved a lot of money because of the great deals your company could offer, which were below market rate if I had dealt directly with the storage company.",
			author: "Pasadena Garden Club",
			title: "The person who assisted me was super…",
			imageSrc: GeorgeRansom
		},
		{
			body: "Abby, the customer service representative at storage.com, was professional, helpful and friendly. She found me a storage space at an excellent price in close proximity to my home. I can't thank her enough.",
			author: "Ann Alarcon",
			title: "A wonderful experience",
			imageSrc: AnnAlarcon
		},
		{
			body: "It was very easy to find storage close to me, and the selection was all mine. I was very happy with this process.",
			author: "Dale Howard",
			title: "Finding Storage",
			imageSrc: SMurphy
		}
	]
};

const militaryHerodescription = `
Secure, flexible storage for service members on the move. Whether you're facing deployment, PCS orders, or temporary duty assignments, military storage facilities provide the space and security you need during transitions. Storage.com connects service members with trusted facilities that understand military move temporary storage requirements, offering short-notice availability, flexible terms, and often military discounts to support those who serve.
`;

export const PSPMilitaryContent = {
	type: "Military",
	sections: [
		{
			title: "Military Storage hero",
			noPadding: true,
			modules: [
				{
					type: "hero-section",
					props: {
						title: "Find the Top Military Storage Units",
						description: militaryHerodescription,
						searchPlaceholder: "Search by city, state, or zip...",
						buttonText: "Find Military Storage",
						heroImages: {
							desktop: HeaderBackgroundDesktop,
							tablet: HeaderBackgroundTablet,
							mobile: HeaderBackgroundMobile
						},
						heroAltText: "Military Storage Hero Image"
					}
				}
			]
		},
		{
			title: "Military Storage Rich Content",
			noPadding: true,
			modules: [
				{
					type: "video-content",
					props: {
						title: "Military Moves: Temporary Storage for PCS and Beyond",
						description:
							"Military storage facilities serve active duty personnel, reservists, and veterans who face unique storage challenges during relocations, deployments, and training assignments. From military vehicle storage to household goods protection, storage facilities near bases provide the flexibility and security that military families need during frequent transitions.",
						mediaType: "image",
						mediaUrl: MilitaryStorageBenefitsImage,
						videoTitle: ""
					}
				}
			]
		},
		{
			title: "Military Storage Options",
			noPadding: true,
			modules: [
				{
					type: "size-chart",
					props: {
						title: "Types of Military Storage Units & Their Uses",
						background: "white",
						storages: [
							{
								title: "Short-Term Military Storage",
								bestFor: [
									"Temporary duty assignments",
									"Flexible lease terms"
								]
							},
							{
								title: "Deployment Storage",
								bestFor: [
									"[Long term storage](https://www.storage.com/blog/long-term-storage-cost/)",
									"Climate control storage needs",
									"Flexible access"
								]
							},
							{
								title: "PCS Storage",
								bestFor: [
									"Temporary storage for military moves",
									"Between duty stations"
								]
							},
							{
								title: "Military Vehicle Storage",
								bestFor: [
									"Specialized spaces for military car storage",
									"Long and short term storage"
								]
							}
						]
					}
				}
			]
		},
		{
			title: "Military Storage Size Comparison",
			noPadding: true,
			modules: [
				{
					type: "size-comparison",
					props: {
						pageType: "psp",
						background: "light-blue",
						title: "Common Military Storage Scenarios and Solutions",
						description:
							"There's a storage unit for every military storage need. This helpful guide will help match you with the right storage unit for your military relocation or deployment.",
						sizes: [
							{
								id: "5x5",
								label: "5x5",
								title: "5' Wide x 5' Long",
								description:
									"* Great for barracks room essentials\n* Personal item, uniform, electronics storage\n* Works great for 1-6 month terms"
							},
							{
								id: "5x10",
								label: "5x10",
								title: "5' Wide x 10' Long",
								description:
									"* Barracks room essentials, training/TDY storage, PCS gap storage\n* Store personal items, apartment essentials, small furniture\n* Works great for 1-6 month terms"
							},
							{
								id: "10x10",
								label: "10x10",
								title: "10' Wide x 10' Long",
								description:
									"* Deployment storage for singles, training/TDY storage, PCS gap storage\n* Store apartment contents and household goods\n* Works for 1-18 months depending on size requirements"
							},
							{
								id: "10x15",
								label: "10x15",
								title: "10' Wide x 15' Long",
								description:
									"* Deployment storage, PCS storage, training/TDY storage\n* Store apartment or small home's contents, household goods, seasonal items\n* Works for 1-18 month storage length"
							},
							{
								id: "10x20",
								label: "10x20",
								title: "10' Wide x 20' Long",
								description:
									"* Deployment storage for families and individuals\n* Store multi-bedroom household contents and even military vehicle storage\n* Storage rental is great for needs up to 36 months"
							},
							{
								id: "10x30",
								label: "10x30",
								title: "10' Wide x 30' Long",
								description:
									"* Military vehicle storage, deployment storage\n* Holds most personal vehicles and some accessories, or the contents of a home\n* Ideal for up to 36 months"
							}
						]
					}
				}
			]
		},
		{
			title: "Military Storage Costs",
			noPadding: true,
			modules: [
				{
					type: "content-section",
					props: {
						title: "Military Storage Costs",
						background: "blue",
						listType: "single",
						content: [
							{
								id: "1",
								value: "Military storage facility costs vary by location, unit size, and amenities. Here are costs based on current pricing from Storage.com locations near military installations:"
							},
							{
								id: "2",
								value: " ### Small Units (5x5 to 5x10) ### \n\n- ***Average Monthly Cost:*** $40-$100\n- ***Best For:*** Single service member essentials"
							},
							{
								id: "3",
								value: "### Medium Units (10x10 to 10x15) ###\n\n- ***Average Monthly Cost:*** $80-$180\n- ***Best For:*** Deployment storage, 1-2 bedroom contents"
							},
							{
								id: "4",
								value: "### Large Units (10x20 to 10x30) ###\n\n- ***Average Monthly Cost:*** $120-$300\n- ***Best For:*** Family household goods, military vehicle storage"
							},
							{
								id: "5",
								value: "### Climate Control (Preferred Amenity) ###\n\n- ***Average Monthly Cost:*** additional $20-60 per month depending on unit size\n- ***Best For:*** Electronics, furniture, deployment storage"
							},
							{
								id: "6",
								value: "*Storage costs near major bases (Fort Bragg, Camp Pendleton, Joint Base Lewis-McChord) tend to run higher due to demand during the PCS season (May-August).*"
							}
						],
						isColumnWise: false
					}
				}
			]
		},
		{
			title: "Military Storage CTA",
			noPadding: true,
			modules: [
				{
					type: "inline-cta",
					props: {
						storageType: "Military",
						subheading: "Make a free reservation in minutes!",
						searchPlaceholder: "Search by city, state, or zip...",
						searchButtonText: "Find Storage",
						image: ctaMan,
						imageAltText: "Find military storage",
						background: "white"
					}
				}
			]
		},
		{
			title: "Customer Reviews",
			noPadding: true,
			modules: [
				{
					type: "reviews",
					props: reviewsContent
				}
			]
		},
		{
			title: "Military Storage FAQs",
			noPadding: true,
			modules: [
				{
					type: "faq",
					props: {
						title: "Military Storage FAQs",
						faqs
					}
				}
			]
		},
		{
			title: "Military Storage Related Content",
			noPadding: true,
			modules: [
				{
					type: "related-content",
					props: {
						heading: "Learn More About Military Storage",
						unitCards: relatedContentCards,
						background: "light-blue"
					}
				}
			]
		},
		{
			title: "Links to Other PSPs",
			noPadding: true,
			modules: [
				{
					type: "psp-links",
					props: {
						storageGridContent: pspLinksContent,
						background: "white"
					}
				}
			]
		},
		{
			title: "Storage Near You",
			noPadding: true,
			modules: [
				{
					type: "nearby-cities",
					props: {
						storageType: "military",
						background: "light-blue"
					}
				}
			]
		}
	]
};

export default PSPMilitaryContent;
